import { AppEntities } from "src/components//../config/entities";
import { IListViewField } from "src/components//Shared/ILIstViewField";
import { NewDocumentListView } from "src/components//Shared/NewDocumentListView";
import { ListView } from "src/components//Shared/ListViews/ListView";
import { DocumentListViewToolbar } from "src/components//Shared/ListViews/DocumentListViewToolbar";
import { DocumentListViewDefaultToolbarButtons } from "src/components//Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";

const ExpenseBanksList = () => {
  const fields: IListViewField[] = [
    {
      title: "Company",
      fieldName: "companyName"
    },
    {
      title: "Vendor",
      fieldName: "vendorCustomerName"
    },
    {
      title: "Currency",
      fieldName: "currencyName"
    },
    {
      title: "Bank Account",
      fieldName: "bankAccountName"
    },
    {
      title: "Payment Request",
      fieldName: "baseDocumentAtPresentationName"
    },
    {
      title: "Amount",
      fieldName: "amount"
    }
  ];

  return (
    <>
      <ListView
        fields={fields}
        entity={AppEntities.ExpenseBankPayments}
        createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};

export default ExpenseBanksList;
